
<template>
    <div class="bg-gray-600 ">
        <div class="flex flex-row flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8">
            <v-nav-link v-for="r in routes" v-show="r.show" :href="r.route" :active="r.active">
                {{ r.name }}
            </v-nav-link>
        </div>
    </div>
</template>

<script>
import VNavLink from "@/Components/NavLink.vue";

export default {
    components: {
        VNavLink,
    },
    data() {
        return {
            routes: [
                {
                    name: 'Профиль',
                    route: this.route('settings.profile'),
                    active: this.route().current('settings.profile'),
                    show: true,
                },
                {
                    name: 'Журнал авторизаций',
                    route: this.route('settings.authorizationLog'),
                    active: this.route().current('settings.authorizationLog'),
                    show: this.access('settings', 'auth_logs'),
                },
                {
                    name: 'Журнал действий',
                    route: this.route('settings.actions-log'),
                    active: this.route().current('settings.actions-log'),
                    show: this.access('settings', 'action_logs'),
                },
                {
                    name: 'Управление менеджерами',
                    route: this.route('settings.users.index'),
                    active: this.route().current('settings.users.index'),
                    show: this.access('settings', 'manage_users'),
                },
            ],
        }
    },
}
</script>

